<template>
  <div>
    <ts-card class="m-t-10">
      <div class="row">
        <div class="col-md-12">
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template slot-scope="{ record }">
              <td>{{ record.schedule_time }}</td>
              <td class="text-center ts-whitespace-no-wrap" width="13%">
                <p class="text-primary" v-show="hasClass(record.Monday)">
                  <b>{{ record.Monday.class_name }}</b>
                </p>
                <p class="line-hieght">
                  {{ record.Monday.subject }}
                </p>
                <p class="line-hieght">
                  {{
                    record.Monday.room_name
                      ? 'Room: ' + record.Monday.room_name
                      : ''
                  }}
                </p>
              </td>
              <td class="text-center ts-whitespace-no-wrap" width="13%">
                <p class="text-primary" v-show="hasClass(record.Tuesday)">
                  <b>{{ record.Tuesday.class_name }}</b>
                </p>
                <p class="line-hieght">
                  {{ record.Tuesday.subject }}
                </p>
                <p class="line-hieght">
                  {{
                    record.Tuesday.room_name
                      ? 'Room: ' + record.Tuesday.room_name
                      : ''
                  }}
                </p>
              </td>
              <td class="text-center ts-whitespace-no-wrap" width="13%">
                <p class="text-primary" v-show="hasClass(record.Wednesday)">
                  <b>{{ record.Wednesday.class_name }}</b>
                </p>
                <p class="line-hieght">
                  {{ record.Wednesday.subject }}
                </p>
                <p class="line-hieght">
                  {{
                    record.Wednesday.room_name
                      ? 'Room: ' + record.Wednesday.room_name
                      : ''
                  }}
                </p>
              </td>
              <td class="text-center ts-whitespace-no-wrap" width="13%">
                <p class="text-primary" v-show="hasClass(record.Thursday)">
                  <b>{{ record.Thursday.class_name }}</b>
                </p>
                <p class="line-hieght">
                  {{ record.Thursday.subject }}
                </p>
                <p class="line-hieght">
                  {{
                    record.Thursday.room_name
                      ? 'Room: ' + record.Thursday.room_name
                      : ''
                  }}
                </p>
              </td>
              <td class="text-center ts-whitespace-no-wrap" width="13%">
                <p class="text-primary" v-show="hasClass(record.Friday)">
                  <b>{{ record.Friday.class_name }}</b>
                </p>
                <p class="line-hieght">
                  {{ record.Friday.subject }}
                </p>
                <p class="line-hieght">
                  {{
                    record.Friday.room_name
                      ? 'Room: ' + record.Friday.room_name
                      : ''
                  }}
                </p>
              </td>
              <td class="text-center ts-whitespace-no-wrap" width="13%">
                <p class="text-primary" v-show="hasClass(record.Saturday)">
                  <b>{{ record.Saturday.class_name }}</b>
                </p>
                <p class="line-hieght">
                  {{ record.Saturday.subject }}
                </p>
                <p class="line-hieght">
                  {{
                    record.Saturday.room_name
                      ? 'Room: ' + record.Saturday.room_name
                      : ''
                  }}
                </p>
              </td>
            </template>
          </ts-table>
        </div>
      </div>
    </ts-card>
  </div>
</template>
<script>
export default {
  name: 'schedule',
  data() {
    return {
      resources: [],
      loading: false
    }
  },
  created() {
    this.getSchedule()
  },
  computed: {
    columns() {
      return [
        {
          name: this.$t('homePage.studyTime')
        },
        {
          name: this.$t('homePage.monday'),
          style: 'text-align: center'
        },
        {
          name: this.$t('homePage.tuesday'),
          style: 'text-align: center'
        },
        {
          name: this.$t('homePage.wednesday'),
          style: 'text-align: center'
        },
        {
          name: this.$t('homePage.thursday'),
          style: 'text-align: center'
        },
        {
          name: this.$t('homePage.friday'),
          style: 'text-align: center'
        },
        {
          name: this.$t('homePage.saturday'),
          style: 'text-align: center'
        }
      ]
    }
  },
  methods: {
    getSchedule() {
      this.loading = true
      this.$store
        .dispatch('home/teacher/schedule')
        .then(response => {
          this.loading = false
          let schedules = response.data
          schedules.forEach(schedule => {
            for (let prop in schedule) {
              let parsedJson = this.tryParseJSON(schedule[prop])
              if (!parsedJson) continue
              schedule[prop] = parsedJson
            }
          })
          this.resources = schedules
        })
        .catch(error => {
          this.loading = false
          this.$emit('close')
          this.$toasted.error(error.message)
        })
    },
    hasClass: () => o => {
      return !isEmpty(o)
    },
    tryParseJSON(jsonString) {
      try {
        let o = JSON.parse(jsonString)

        if (o && typeof o === 'object') {
          return o
        }
      } catch (e) {}

      return false
    }
  }
}
</script>
<style lang="css" scoped>
.font-bold {
  font-weight: bold;
}
.line-hieght {
  /* line-height: 6px; */
}
table {
  width: 100%;
}
table > thead > tr > th {
  padding: 5px;
  border: 1px solid #dcdcdc;
}
table > tbody > tr > td {
  border: 1px solid #dcdcdc;
  padding: 4px 7px;
  vertical-align: middle;
  /* line-height: px; */
}
.tittle {
  text-transform: uppercase;
}
</style>
